var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "lc-stream-background" }, [
    !_vm.stream
      ? _c(
          "div",
          {
            staticClass:
              "flex items-center justify-center text-white text-opacity-60 text-lg font-primary",
            staticStyle: { height: "38vw" },
          },
          [_c("span", [_vm._v("Loading...")])]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.stream
      ? _c(
          "div",
          {
            staticClass: "grid grid-cols-1 md:overflow-hidden py-8",
            class: { "md:grid-cols-5 lg:grid-cols-3 gap-8": !!_vm.program },
          },
          [
            _c(
              "div",
              {
                staticClass: "md:col-span-3 lg:col-span-2 pl-4 pr-4",
                class: { "md:pl-6 md:pr-0": !!_vm.program },
              },
              [
                _c("Player", {
                  attrs: { stream: _vm.stream, source: _vm.currentSource },
                  on: {
                    register: function ($event) {
                      _vm.player = $event
                    },
                  },
                }),
                _vm._v(" "),
                _vm.allSources.length > 1
                  ? _c("Switcher", {
                      attrs: {
                        sources: _vm.allSources,
                        current: _vm.currentSource,
                      },
                      on: {
                        click: function (index) {
                          return (this$1.currentSourceIndex = index)
                        },
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _vm.program
              ? _c(
                  "div",
                  {
                    staticClass:
                      "relative md:col-span-2 lg:col-span-1 pl-4 md:pl-0",
                  },
                  [
                    _c("div", { staticClass: "lc-stream-reveal-gradient" }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-col md:absolute md:inset-0 overflow-y-auto md:pr-6 pr-4",
                      },
                      [
                        _c("CurrentlyOn", {
                          attrs: {
                            stream: _vm.stream,
                            currentTime: _vm.currentTime,
                          },
                        }),
                        _vm._v(" "),
                        _c("Program", {
                          attrs: {
                            stream: _vm.stream,
                            currentTime: _vm.currentTime,
                          },
                          on: { "seek-to": _vm.seekTo },
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }